import { PictureRotation } from '@app/core/enums/picture-rotation.enum';

/** Order in which rotations cycle when the user rotates a picture. */
export const ROTATION_SEQUENCE = [
  PictureRotation.Deg0,
  PictureRotation.Deg90,
  PictureRotation.Deg180,
  PictureRotation.Deg270,
];

/** Fraction of the viewport the finger must travel to commit a slide change. */
export const COMMIT_THRESHOLD_RATIO = 0.4;

/** Per-move pointer speed (px) above which a quick flick commits regardless of distance. */
export const FLICK_VELOCITY = 8;

/** How much an off-centre (neighbor) slide is shrunk. */
export const MIN_SCALE = 0.65;

/** How much an off-centre (neighbor) slide is dimmed. */
export const MIN_OPACITY = 0.2;
